import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Printer } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { InvoiceDocument } from "@/components/InvoiceDocument";
import { Button } from "@/components/ui/button";
import { PdfButton } from "@/components/PdfButton";

export default function CreditNoteView() {
  const { id } = useParams();
  const { t } = useLang();
  const [cn, setCn] = useState(null);
  const [co, setCo] = useState(null);
  useEffect(() => {
    api.get(`/credit-notes/${id}`).then((r) => setCn(r.data));
    api.get("/company").then((r) => setCo(r.data));
  }, [id]);
  if (!cn || !co) return <div className="text-slate-400">{t("loading")}</div>;
  return (
    <div data-testid="credit-note-view-page">
      <div className="no-print mb-6 flex flex-wrap items-center gap-2">
        <Button asChild variant="ghost" data-testid="cn-back-btn"><Link to={`/invoices/${cn.invoice_id}`}><ArrowLeft className="me-1 h-4 w-4 rtl:-scale-x-100" />{t("back")}</Link></Button>
        <span className="rounded-full bg-red-50 px-2.5 py-0.5 text-xs font-semibold text-[#A50E1F] ring-1 ring-red-200">{t("creditNote")}</span>
        <div className="ms-auto flex gap-2"><PdfButton kind="credit_note" id={cn.id} name={cn.number} testid="cn-pdf-btn" /><Button data-testid="cn-print-btn" onClick={() => window.print()} className="bg-[#0B1220] hover:bg-slate-800"><Printer className="me-1 h-4 w-4" />{t("print")}</Button></div>
      </div>
      <InvoiceDocument inv={cn} co={co} kind="credit_note" />
    </div>
  );
}
